import React, { useState } from 'react';
import { IconButton } from '../../components/Button';
import Tether from '../../components/Tether';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import tocIcon from '../../icons/non-prefilled/16x16/tableOfContentsNew.svg';
import ClickOutsideHandler from '../../utils/ClickOutsideHandler';
import ConnectedTableOfContents from '../actionButtons/ConnectedTableOfContents';
import TableOfContents from '../actionButtons/TableOfContents';
import * as styles from './PostModalViewTOC.module.scss';

const POST_FRAGMENT = gql(`
  fragment PostModalViewTOC_post on Post {
    id
    ...TableOfContents_post
  }
`);

interface PostModalViewTOCProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  portalContainer: HTMLElement | null;
}

const PostModalViewTOC = ({ post, portalContainer }: PostModalViewTOCProps) => {
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  if (!portalContainer) return null;

  return (
    <ConnectedTableOfContents postId={post.id}>
      {(tocProps) => {
        const hasHeaders = tocProps.headers.length > 0;

        return (
          hasHeaders && (
            <ClickOutsideHandler onClickOutside={() => setIsOpen(false)}>
              <IconButton
                ref={setAnchorElement}
                aria-label="Table of Contents"
                size="md"
                onClick={() => setIsOpen(!isOpen)}
              >
                {tocIcon}
              </IconButton>
              {isOpen && (
                <Tether
                  placement="bottom-start"
                  portalContainer={portalContainer}
                  offset={8}
                  positionedView={
                    <div className={styles.tocContainer}>
                      <h4 className={styles.title}>Table of Contents</h4>
                      <TableOfContents {...tocProps} post={post} />
                    </div>
                  }
                  anchorElement={anchorElement}
                />
              )}
            </ClickOutsideHandler>
          )
        );
      }}
    </ConnectedTableOfContents>
  );
};

export default PostModalViewTOC;
